import { useEffect, useState } from "react";
import useAxiosPublic from "./useAxiosPublic";

export const useSettingsFetch = (settingKey) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(true);
  const axiosPublic = useAxiosPublic();

  useEffect(() => {
    const fetchSetting = async () => {
      try {
        setLoading(true);
        const response = await axiosPublic.get(`setting/${settingKey}`);
        const responseData = response?.data;
        setData(responseData);
      } catch (error) {
        console.error(`Error fetching ${settingKey}:`, error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchSetting();
  }, [settingKey, axiosPublic, setError]);

  return { data, error, loading };
};
